<template>
  <div class="buy-panel-product-image">
    <base-spinner v-show="showSpinner" :class="{'position-higher': isSpinnerPositionHigher}" ></base-spinner>
    <div class="buy-panel-product-image--container">
      <span v-if="isApparel && imageSrc && !this.showSpinner">FRONT</span>
      <img
      :class="[
        'buy-panel-product-image-model-image',
        {
          'buy-panel-product-image-model-image--apparel': isApparel
        }
      ]"
      :src="imageSrc"
      :alt="pdm?.product_name"
      @load="hideSpinner(true)"
      v-show="!this.showSpinner"
    />
    </div>
    <div class="buy-panel-product-image--container" v-if="isApparel && imageSrcAdditional">
      <span v-if="!this.showSpinner">BACK</span>
      <img
      :class="[
        'buy-panel-product-image-model-image',
        {
          'buy-panel-product-image-model-image--apparel': isApparel
        }
      ]"
      :src="imageSrcAdditional"
      :alt="pdm?.product_name"
      @load="hideSpinner(true)"
      v-show="!this.showSpinner"
    />
    </div>
  </div>
</template>
<script>
import baseSpinner from '@/components/Spinner';
import { getRegion, getLocale, getCaid, getConfigurationObject } from "@/data/regionInfo";

export default {
  name: "productImage",
  components: {
    baseSpinner
  },
  props: {
    recipeId: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: 'customizer'
    },
    isSpinnerPositionHigher:{
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      imageSrc: "",
      imageSrcAdditional: "",
      showSpinner: true
    };
  },
  computed:{
    pdm() {
      return this.$store.state.utils?.pdm;
    },
    isApparel() {
      return this.$store.getters['utils/isApparelEnabled'];
    },
    configuration() {
      return this.$store.state.utils.configuration;
    }
  },
  methods: {
    hideSpinner(hide) {
      this.showSpinner = !hide;
    },
    /**
     * @function getProductImage
     * Get product image sending featured view
     */
    getProductImage({ recipe_id }) {
      const { pdm } = this.$store.state.utils;
      const randomizerModels = this.$store.state.randomizer.modelsData;
      const randomizerModelName = this.$store.state.randomizer.selectedStyle;
      const randomizerView  = randomizerModels[randomizerModelName] ?
        randomizerModels[randomizerModelName].featured_views.buy_panel : null;
      const buyPanelViews = pdm && pdm.product_images && typeof pdm.product_images.featured_views.buy_panel !== "undefined"
        ? pdm.product_images.featured_views.buy_panel
        : { size: "md", view: "left" };
      const miniCartViews = this.configuration?.vue_component_settings?.buy_panel?.mini_cart_view
        ? this.configuration.vue_component_settings.buy_panel.mini_cart_view
        : { size: "md-square-white", view: "left_square" };
      const featuredView = randomizerView || buyPanelViews;
      const images = randomizerView ?
       [randomizerView,miniCartViews] :
        Array.isArray(buyPanelViews) ?
        buyPanelViews.concat([miniCartViews]):
       [buyPanelViews,miniCartViews];
      this.$store
        .dispatch("ugc/tempData/GET_PRODUCT_IMAGES_BY_RECIPE_ID", {
          recipe_id,
          locale: getLocale(),
          type: this.$props.type,
          images
        })
        .then(data => {
          let productImage = '';
          const minicartImage = data[miniCartViews.view + "_view"][miniCartViews.size];;
          if (Array.isArray(featuredView)){
            // Apparel use two images for the buy panel (Front - Back)
            productImage =
            [
              data[featuredView[0].view + "_view"][featuredView[0].size],
              data[featuredView[1].view + "_view"][featuredView[1].size]
            ];
          }
          else
            productImage = data[featuredView.view + "_view"][featuredView.size];
          this.$store.commit('modals/SET_BUY_PANEL_PRODUCT_IMAGE', { recipeId: recipe_id, data: productImage });
          this.$store.commit("buyPanel/SET_CART_IMAGE", minicartImage);
          if(Array.isArray(productImage)){
            this.imageSrc = productImage[0];
            this.imageSrcAdditional = productImage[1];
          } else {
            this.imageSrc = productImage;
          }
        });
    },
    resetElements() {
      this.imageSrc = "";
      this.showSpinner = true;
      this.$eventBus.$emit("hide-customs-spinner", false);
    }
  },
  created() {
    this.$eventBus.$on('buypanel-open', this.resetElements);
    this.$eventBus.$on('recipe-saved', this.getProductImage);
  },
  beforeDestroy() {
    this.$eventBus.$off('buypanel-open', this.resetElements);
    this.$eventBus.$off('recipe-saved', this.getProductImage);
  }
};
</script>
